export const TableDataCellProp = Object.freeze({
    CellType: 'cellType',
    ColumnName: 'columnName',
    Text: 'text',
    OnClickAction: 'onClickAction',
    BoolValue: 'boolValue',
    Actions: 'actions',
});